export default __webpack_public_path__ + "811322a.png";